/**
 * Legacy Licensing script.
 *
 * @package cf-conditional-content
 */

import './tabs';

(function () {
	'use strict';

	var settingsForm = document.getElementById('cf-cc-settings-license-key-form'),
		settingsDisplay = document.getElementById('cf-cc-license-key-display');

	// Abort if we're not on the cf-conditional-content Settings screen.
	if (!settingsForm) {
		return;
	}

	/*
	 * If a license key has already been set, we'll display a masked version.
	 *
	 * Clicking the button within settingsDisplay will replace the display with the hidden form.
	 */
	if (settingsDisplay && settingsForm.classList.contains('hide-if-js')) {
		settingsForm.setAttribute('hidden', '');
		settingsForm.classList.remove('hide-if-js');

		settingsDisplay.addEventListener('click', function (e) {
			if ('BUTTON' !== e.target.tagName) {
				return;
			}

			settingsDisplay.setAttribute('hidden', '');
			settingsForm.removeAttribute('hidden');
			document.getElementById('cf-cc-license-key-input').focus();
		});
	}
}());
